import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useLargeModalStyles = makeStyles({
  root: {
    minWidth: '80vw',
  },
  twoColumnContainer: {
    display: 'grid',
    gridTemplateColumns: '50% auto',
    gridAutoRows: 'min-content',
    gap: '5px',
  },
  groupBasicLH: {
    ...shorthands.gridArea(2, 1, 3, 2),
  },
  groupBasicRH: {
    ...shorthands.gridArea(2, 2, 3, 3),
  },
  groupBasicHeader: {
    ...shorthands.gridArea(1, 1, 2, 3),
  },
  groupModelTree: {
    ...shorthands.gridArea(3, 1, 4, 2),
  },
  groupViewConfig: {
    ...shorthands.gridArea(3, 2, 4, 3),
  },
  groupLH: {
    gridColumnStart: 1,
    gridColumnEnd: 2,
  },
  groupRH: {
    gridColumnStart: 2,
    gridColumnEnd: 3,
  },
  groupSpanCol: {
    gridColumnStart: 1,
    gridColumnEnd: 3,
  },
  groupRow1: {
    gridRowStart: 1,
    gridRowEnd: 2,
  },
  groupRow2: {
    gridRowStart: 2,
    gridRowEnd: 3,
  },
  groupRow3: {
    gridRowStart: 3,
    gridRowEnd: 4,
  },
  groupRow4: {
    gridRowStart: 4,
    gridRowEnd: 5,
  },
  field: {
    borderRadius: tokens.borderRadiusSmall,
    ...shorthands.borderStyle('solid'),
    ...shorthands.borderColor(
      tokens.colorNeutralStroke1,
      tokens.colorNeutralStroke1,
      tokens.colorNeutralStrokeAccessible,
      tokens.colorNeutralStroke1,
    ),
    ...shorthands.borderWidth('1px'),
  },
});
